import { useLanguage } from '../../lib/i18n/LanguageContext';

const WineListPairing = () => {
  const { t } = useLanguage();

  return (
    <div className="mt-16 bg-white p-4 md:p-8 rounded-lg shadow-md">
      <h3 className="font-serif text-xl lg:text-2xl font-semibold text-neutral-900 text-center mb-4">
        {t.wineList.pairing.title}
      </h3>
      <p className="text-neutral-700 text-center mb-6 text-base leading-relaxed">
        {t.wineList.pairing.description}
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
        {t.wineList.pairing.categories.map((category, index) => (
          <div key={index} className="p-4">
            <h4 className="font-serif font-medium text-base lg:text-lg text-red-800 mb-2">
              {category.title}
            </h4>
            <p className="text-neutral-600 text-base leading-relaxed">{category.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WineListPairing;
